import { render, staticRenderFns } from "./JciIndiaScoringTable.vue?vue&type=template&id=5e55679e"
import script from "./JciIndiaScoringTable.vue?vue&type=script&lang=js"
export * from "./JciIndiaScoringTable.vue?vue&type=script&lang=js"
import style0 from "./JciIndiaScoringTable.vue?vue&type=style&index=0&id=5e55679e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports